let notMatch_IJob_Budget = (model) => {
    // return model.itemName != "上会服务人员服务费" && model.itemName != "视频会议"
    return model.itemName != "上会服务人员服务费"
}
let isMatch_IJob_Budget = (model) => {
    // 带入业务逻辑，很无奈
    let eventMsg = JSON.parse(sessionStorage.getItem("eventMsg") || sessionStorage.getItem("model"));
    let eventSize = eventMsg.itsExtData.eventSize;
    return model.itemName == "上会服务人员服务费" && eventSize != "level2"
}
let isMatch_IJob_Budget_Onsite = (model) => {
    return model.itemName == "上会服务人员服务费" && model.serviceType == "现场人员"
}
let video_IJob_Budget = (model) => {
    return model.itemName == "视频会议(取消使用)"
}
export const budgetValidator = {
    itemName: {
        preCondition:function(model){
            return model.itemName != "视频会议(取消使用)"
        },
        required: true,
        description: "预算项目不能为空"
    },
    serviceType: {
        preCondition: isMatch_IJob_Budget,
        required: true,
        description: "服务类型不能为空"
    },
    peopleNum: {
        preCondition: isMatch_IJob_Budget,
        required: true,
        description: "人数不能为空"
    },
    startDate: {
        preCondition: isMatch_IJob_Budget_Onsite,
        required: true,
        description: "开始时间不能为空",
        expression:function(model){
            return new Date(model.endDate) < new Date(model.startDate)
        },
        expressionMsg:"结束时间不能小于开始时间"
    },
    endDate: {
        preCondition: isMatch_IJob_Budget_Onsite,
        required: true,
        description: "结束时间不能为空"
    },
    days: {
        preCondition: isMatch_IJob_Budget,
        required: true,
        description: "天数不能为空"
    },
    amount: {
        preCondition: notMatch_IJob_Budget,
        required: true,
        description: "预算金额不能为空",
        regExp: /^\d+(\.\d+)?$/,
        regExpMsg: "金额格式不正确"
    },
    descr:{
        preCondition:function(model){
            return model.itemName == "其他费用(现场垫付费用)"
        },
        required:true,
        description:"备注不能为空"
    },
    meetingNum: {
        preCondition: video_IJob_Budget,
        // required: true,
        required: false,
        description: "场次不能为空"
    },
    mettingType: {
        preCondition: video_IJob_Budget,
        // required: true,
        required: false,
        description: "会议室类型不能为空"
    }
}



// WEBPACK FOOTER //
// ../scripts/validators/budgetValidator.js